module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAPCAMAAADXs89aAAAARVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////9SnXPCAAAAFnRSTlMA5PIhNqO7Je1TKrKZPffe1cWGdWEcj+5ubAAAAFhJREFUGNPNyMcNgEAMRFGzAewNZKb/UrHWJ4sGeIcZ6RPRFeCsJ6kHmBygaC6Yycnouss3p5/l6nMbueCIQ0r2FZ3UBhMYhjWKNJhIMFmEdjCH4RZ7ZkwvA1cIN1Uy2tEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-mac-active.png
// module id = Awcq
// module chunks = 0 1